import { typeIdObj } from '@home/utils/buriedPoint';

import type { pointInter as IBuriedPointCfg } from '@home/utils/buriedPoint';

// 页面打点配置表
export const dbuPageLogMes: IRecord<IBuriedPointCfg> = {
  // 用户数据中心季报页
  userDataCenterQuarterReport: {
    typeId: typeIdObj.userCenter,
    pageId: '980001',
    pageName: 'userDataCenterQuarterReport',
    pagePath: '/user-data-center/quarter-report',
    extInfo: '用户数据中心季报页',
  },
  // 内容管理中心报告列表页
  contentManagementCenterReports: {
    typeId: typeIdObj.userCenter,
    pageId: '980101',
    pageName: 'contentManagementCenterReports',
    pagePath: '/content-management-center/reports',
    extInfo: '内容管理中心报告列表页',
  },
  // 内容管理中心报告新增页
  contentManagementCenterReportsAdd: {
    typeId: typeIdObj.userCenter,
    pageId: '980102',
    pageName: 'contentManagementCenterReportsAdd',
    pagePath: '/content-management-center/reports/add',
    extInfo: '内容管理中心报告新增页',
  },
  // 内容管理中心报告编辑页
  contentManagementCenterReportsEdit: {
    typeId: typeIdObj.userCenter,
    pageId: '980103',
    pageName: 'contentManagementCenterReportsEdit',
    pagePath: '/content-management-center/reports/edit',
    extInfo: '内容管理中心报告编辑页',
  },
} as any;

// 按钮打点
export const dbuBtnLogMes: IRecord = {
  // 用户数据中心季报页保存图片
  userDataCenterQuarterReportSaveImage: {
    typeId: typeIdObj.userCenter,
    pageId: '980001',
    buttonId: '980001001',
    extInfo: '用户数据中心季报页 保存图片',
  },
  // 用户数据中心季报页复制图片
  userDataCenterQuarterReportCopyImage: {
    typeId: typeIdObj.userCenter,
    pageId: '980001',
    buttonId: '980001002',
    extInfo: '用户数据中心季报页 复制图片',
  },
  // 用户数据中心季报页下载按钮
  userDataCenterQuarterReportDownloadButton: {
    typeId: typeIdObj.userCenter,
    pageId: '980001',
    buttonId: '980001003',
    extInfo: '用户数据中心季报页 下载按钮',
  },
  // 内容管理中心报告页 新增按钮
  contentManagementCenterReportsAddSubmit: {
    typeId: typeIdObj.userCenter,
    pageId: '980101',
    buttonId: '980101001',
    extInfo: '内容管理中心报告页 新增按钮',
  },
  // 内容管理中心报告页 编辑按钮
  contentManagementCenterReportsEditSubmit: {
    typeId: typeIdObj.userCenter,
    pageId: '980101',
    buttonId: '980101002',
    extInfo: '内容管理中心报告页 编辑按钮',
  },
  // 内容管理中心报告页 删除按钮
  contentManagementCenterReportsDeleteSubmit: {
    typeId: typeIdObj.userCenter,
    pageId: '980101',
    buttonId: '980101003',
    extInfo: '内容管理中心报告页 删除按钮',
  },
  // 内容管理中心报告新增页 保存按钮
  contentManagementCenterReportsAddSaveSubmit: {
    typeId: typeIdObj.userCenter,
    pageId: '980102',
    buttonId: '980102001',
    extInfo: '内容管理中心报告新增页 保存按钮',
  },
  // 内容管理中心报告新增页 返回按钮
  contentManagementCenterReportsAddBackSubmit: {
    typeId: typeIdObj.userCenter,
    pageId: '980102',
    buttonId: '980102002',
    extInfo: '内容管理中心报告新增页 返回按钮',
  },
  // 内容管理中心报告新增页 预览按钮
  contentManagementCenterReportsAddPreviewSubmit: {
    typeId: typeIdObj.userCenter,
    pageId: '980102',
    buttonId: '980102003',
    extInfo: '内容管理中心报告新增页 预览按钮',
  },
  // 内容管理中心报告新增页 分享按钮
  contentManagementCenterReportsAddShareSubmit: {
    typeId: typeIdObj.userCenter,
    pageId: '980102',
    buttonId: '980102004',
    extInfo: '内容管理中心报告新增页 分享按钮',
  },
  // 内容管理中心报告新增页 上传封面按钮
  contentManagementCenterReportsAddUploadCoverSubmit: {
    typeId: typeIdObj.userCenter,
    pageId: '980102',
    buttonId: '980102008',
    extInfo: '内容管理中心报告新增页 上传封面按钮',
  },
  // 内容管理中心报告新增页 上传头像按钮
  contentManagementCenterReportsAddUploadAvatarSubmit: {
    typeId: typeIdObj.userCenter,
    pageId: '980102',
    buttonId: '980102009',
    extInfo: '内容管理中心报告新增页 上传头像按钮',
  },
  // 内容管理中心报告编辑页 保存按钮
  contentManagementCenterReportsEditSaveSubmit: {
    typeId: typeIdObj.userCenter,
    pageId: '980103',
    buttonId: '980103001',
    extInfo: '内容管理中心报告编辑页 保存按钮',
  },
  // 内容管理中心报告编辑页 返回按钮
  contentManagementCenterReportsEditBackSubmit: {
    typeId: typeIdObj.userCenter,
    pageId: '980103',
    buttonId: '980103002',
    extInfo: '内容管理中心报告编辑页 返回按钮',
  },
  // 内容管理中心报告编辑页 预览按钮
  contentManagementCenterReportsEditPreviewSubmit: {
    typeId: typeIdObj.userCenter,
    pageId: '980103',
    buttonId: '980103003',
    extInfo: '内容管理中心报告编辑页 预览按钮',
  },
  // 内容管理中心报告编辑页 分享按钮
  contentManagementCenterReportsEditShareSubmit: {
    typeId: typeIdObj.userCenter,
    pageId: '980103',
    buttonId: '980103004',
    extInfo: '内容管理中心报告编辑页 分享按钮',
  },
  // 内容管理中心报告编辑页 上传封面按钮
  contentManagementCenterReportsEditUploadCoverSubmit: {
    typeId: typeIdObj.userCenter,
    pageId: '980103',
    buttonId: '980103008',
    extInfo: '内容管理中心报告编辑页 上传封面按钮',
  },
  // 内容管理中心报告编辑页 上传头像按钮
  contentManagementCenterReportsEditUploadAvatarSubmit: {
    typeId: typeIdObj.userCenter,
    pageId: '980103',
    buttonId: '980103009',
    extInfo: '内容管理中心报告编辑页 上传头像按钮',
  },
};

// 搜索打点
export const dbuSearchLogMes: IRecord = {
  // 内容管理中心报告列表页 搜索打点
  contentManagementCenterReportsSearch: {
    typeId: typeIdObj.userCenter,
    pageId: '980101',
    pageName: 'contentManagementCenterReports',
    pagePath: '/content-management-center/reports',
    extInfo: '内容管理中心报告列表页 搜索打点',
  },
};
